export const dateFormatter = new Intl.DateTimeFormat('pt-BR')

export const priceFormatter = new Intl.NumberFormat('pt-BR', {
  style: 'currency',
  currency: 'BRL',
})

export function onlyNumbers(value: string) {
  return value.replace(/\D/g, '')
}

export const numberFormatter = new Intl.NumberFormat('pt-BR', {
  minimumIntegerDigits: 1,
  minimumFractionDigits: 2,
  maximumFractionDigits: 2,
})

export const numberFormatterFourDigits = new Intl.NumberFormat('pt-BR', {
  minimumIntegerDigits: 1,
  minimumFractionDigits: 2,
  maximumFractionDigits: 4,
})

export const numberFormatterThreeDigits = new Intl.NumberFormat('pt-BR', {
  minimumIntegerDigits: 1,
  minimumFractionDigits: 2,
  maximumFractionDigits: 3,
})

export function formatNumber(value: number) {
  return numberFormatter.format(value)
}

export function OnlyLetterAndNumber(value: string) {
  return value.normalize('NFD').replace(/([\u0300-\u036f]|[^0-9a-zA-Z\s])/g, '')
}

export function isNumber(value: string) {
  return (
    !Number.isNaN(Number.parseFloat(value)) &&
    Number.isFinite(Number.parseFloat(value))
  )
}

export function toCurrecy(number: number) {
  const formatter = new Intl.NumberFormat('en-US', {
    minimumIntegerDigits: 1,
    maximumSignificantDigits: 5,
  })

  return formatter.format(number)
}
